<template>
	<div>
		<transition name="fade">
		    <div class="position-fixed page-loading" v-if="loading">
		        <div class="loader position-absolute">
		            <i class="fas fa-circle-notch fa-spin"></i>
		        </div>
		    </div>
		</transition>
	</div>
</template>

<script>

import loader from './loader.vue'

export default {
    props: {
    	loading: Boolean,
    },
};

</script>